// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__R19sb","head":"Table_head__2hTjV","col":"Table_col__2l1tW"};